import { useActor } from '@xstate/react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Actor } from '../../machines/ProfileListMachine';
import { Feedback } from '../Feedback/Feedback';
import { EditListItem } from './EditListItem';
import './Blocked.scss';

export function Blocked({ actor }: { actor: Actor }) {
  const [state, send] = useActor(actor);
  const { t } = useTranslation();

  const favorites = state.context.profiles.filter((p) =>
    state.context.profile.blocked.includes(p.id)
  );

  return (
    <div className="page blocked">
      <Helmet>
        <title>
          {t('title')} - {t('editLists.blocked.heading')}
        </title>
      </Helmet>
      <h2 className="heading blocked__heading">
        {t('editLists.blocked.heading')}
      </h2>
      <p className="blocked__intro">{t('editLists.blocked.intro')}</p>
      {state.matches('remove.idle.invalid') && (
        <Feedback>{t('editLists.blocked.error')}</Feedback>
      )}
      <ul className="edit-list">
        {favorites.map((profile) => (
          <EditListItem
            key={profile.id}
            profileClick={() => {
              send({ type: 'viewProfile', profile });
            }}
            profileImage={profile.images[0].xs}
            profileName={profile.name}
            editClick={() => {
              send({ type: 'removeProfile', profile });
            }}
            editLabel={t('editLists.removeButton')}
            userStatus={profile.status}
          />
        ))}
      </ul>
    </div>
  );
}
